import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, matchPath, Outlet, useLocation, useParams } from 'react-router-dom';
import { Divider, Grid, Paper, Stack, Tab, Tabs, Typography, Link as MuiLink } from '@mui/material';

import { RouterPaths } from '../../router/paths';
import { permissionsCheck } from '../../utils/permission';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

export const FeeGroupDetails: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { fee_group_id } = useParams();
  const hasPermissionToViewFeeLevels = permissionsCheck(['READ_FEE_LEVELS']);
  const hasPermissionToViewFees = permissionsCheck(['READ_FEES']);

  // active tab logic
  const tabsPaths = [RouterPaths.Fees, RouterPaths.FeeLevels];
  const activeTab = tabsPaths.filter((path) => matchPath(path, pathname))[0] ?? 'fees';

  return (
    <>
      <Stack direction="row" alignItems="flex-end" spacing={2} pl={3} pt={1}>
        <MuiLink underline="hover" component={Link} to={RouterPaths.FeeGroups}>
          <Stack direction="row" alignItems="stretch" spacing={0.2}>
            <ArrowBackIcon fontSize="inherit" />
            <Typography variant="caption" component="span">
              {t('fee-groups.back-to-groups')}
            </Typography>
          </Stack>
        </MuiLink>

        <Divider orientation="vertical" />
      </Stack>
      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Tabs value={activeTab} variant="scrollable" scrollButtons="auto">
            {hasPermissionToViewFees && (
              <Tab
                label={t('fee-groups.tabs.fees')}
                component={Link}
                to={`${RouterPaths.FeeGroups}/${fee_group_id}/fee-group-details/fees`}
                value={RouterPaths.Fees}
                sx={{ textTransform: 'none' }}
              />
            )}
            {hasPermissionToViewFeeLevels && (
              <Tab
                label={t('fee-groups.tabs.fee-levels')}
                component={Link}
                to={`${RouterPaths.FeeGroups}/${fee_group_id}/fee-group-details/fee-levels`}
                value={RouterPaths.FeeLevels}
                sx={{ textTransform: 'none' }}
              />
            )}
          </Tabs>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </Paper>
      </Grid>
    </>
  );
};
